import React, { useState, useEffect } from 'react';
import axiosClient from 'api/axiosClient'

import { Container, Row, Col } from 'reactstrap';
import Loader from "react-loader-spinner";
import ContentNews from './ContentNews';
import ContentLabel from './ContentLabel';
import ContentUpComing from './ContentUpComing';
import "../../assets/css/custom.css"



export default function News() {
    const [infoLatest, setInfoLatest] = useState()
    const [infoRelated, setInfoRelated] = useState()
    const [loaded, setLoaded] = useState()
    const pathSplit = window.location.pathname.split('/')
    const lang = pathSplit[1]
    const isVietnamese = lang === 'vi'
    useEffect(() => {
        setLoaded(false)
        const requestUrl_1 = `/news?unit=Home&page=1&size=10`;
        const requestUrl_2 = `/news/getBySpotlight?unit=Home&type=highlight`;
        Promise.all([axiosClient.get(requestUrl_1), axiosClient.get(requestUrl_2)])
            .then(([firstResponse, secondResponse]) => {
                setInfoLatest(firstResponse.data)
                setInfoRelated(secondResponse.data)
                setLoaded(true)
            })
            .catch(error => console.log(error));
    }, [])

    return (
        <div className="bg-contentNew">
            <Container>
                {
                    !loaded ? (
                        <Loader type="ThreeDots" color="var(--primary-color)" height="100" width="100" />
                    ) : (
                        <Row>
                            <Col md={8} sm={12}>
                                <ContentLabel tittle='latest_news' /> {/* ✅ Dùng bản dịch */}
                                <ContentNews infoLatest={infoLatest} />
                            </Col>
                            <Col md={4} sm={12}>
                                <ContentUpComing infoRelated={infoRelated} />
                            </Col>
                        </Row>
                    )
                }
            </Container>
        </div>
    )
}
